import { render } from "./CacheManager.vue?vue&type=template&id=a10be738&scoped=true"
import script from "./CacheManager.vue?vue&type=script&lang=js"
export * from "./CacheManager.vue?vue&type=script&lang=js"

import "./CacheManager.vue?vue&type=style&index=0&id=a10be738&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a10be738"]])

export default __exports__